export const KPMG_TEMPLATES = [
  "kpmg_resume",
  "kpmg_ca_resume",
  "kpmg_ca_french_resume",
  "kpmg_au_resume_pptx"
];

export const kpmgBlue = "#00338D";
export const headerColor = "#1E49E2";
export const sidebarBackground = "#F2F2F2";
export const kpmgBlueLight = "#00B8F5";

export const pagePreviewStyle = {
  padding: "36px 59px 40px 59px",
  fontFamily: "arial",
  width: 720,
  height: 540,
  minHeight: 540,
  display: "flex"
};

export const mainSectionCustomFieldNames = ["experience", "summary"];
